import {Component, DoCheck, ViewChild} from '@angular/core';
import {Toast} from 'primeng/toast';
import {DomHandler} from 'primeng/dom';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements DoCheck {

  showMenu: boolean = true;
  @ViewChild(Toast)
  toast: Toast | undefined;

  ngDoCheck(): void {
    if (!(this.toast && this.toast.containerViewChild)) {
      return;
    }
    const requiredZIndex: string = `${DomHandler.zindex}`;
    const el = this.toast.containerViewChild.nativeElement as HTMLElement;
    if (el.style.zIndex !== requiredZIndex) {
      el.style.zIndex = requiredZIndex;
    }
  }

  public switchMenu(): void {
    this.showMenu = !this.showMenu;
  }

}

